<template>
  <div class="teacher-manager">
    <div class="top">
      <div class="radio-group">
        <el-radio-group
          class="school-level-radio"
          v-model="schoolLevel"
          @change="changeSchoolLevel"
        >
          <el-radio-button label="elementary-school">國小</el-radio-button>
          <el-radio-button label="junior-high-school">國中</el-radio-button>
          <el-radio-button label="high-school">高中</el-radio-button>
        </el-radio-group>
        <el-radio-group
          class="subject-radio"
          v-model="subject"
          @change="changeSubject"
        >
          <el-radio-button
            v-for="subject in subjects"
            :key="subject.label"
            :label="subject.label"
            >{{ subject.text }}</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-button type="success" @click="createTeacher">新增老師</el-button>
    </div>
    <el-table
      :data="teachersData.list"
      border
      stripe
      empty-text="沒有資料"
      style="width: 100%"
    >
      <el-table-column prop="school_level" label="層級" width="150">
        <template slot-scope="{ row }">
          <div>{{ levelName(row.school_level) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="subject" label="科目" width="150">
        <template slot-scope="{ row }">
          <div>{{ subjectName(row.subject) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
      <el-table-column prop="photo" label="照片" width="150">
        <template slot-scope="{ row }">
          <div class="center">
            <el-avatar
              v-if="teacherForm.photo"
              class="teacher-photo"
              :src="row.photo"
            ></el-avatar>
          </div> </template
      ></el-table-column>

      <el-table-column label="修改" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="warning" @click="editTeacher(row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="刪除" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="danger" @click="remove(row.id)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="size"
      :total="teachersData.total"
      :current-page.sync="currentPage"
      @current-change="pageChange"
    >
    </el-pagination>
    <TeacherEditor
      :teacherEditorVisible.sync="teacherEditorVisible"
      :teacherForm="teacherForm"
      :isCreate="isCreate"
      @saveTeacher="saveTeacher"
    >
    </TeacherEditor>
  </div>
</template>

<script>
import TeacherEditor from '@/components/management/TeacherEditor';
import Api from '@/api/MaganmentApi';
import Swal from 'sweetalert2';
import _ from 'lodash';

export default {
  data() {
    return {
      size: 10,
      currentPage: 1,
      teacherEditorVisible: false,
      isCreate: false,
      schoolLevel: 'elementary-school',
      subject: '',
      teachersData: {
        list: [],
        total: 0,
      },
      teacherForm: {
        school_level: '',
        subject: '',
        name: '',
        photo: '/static-img/avatar.png',
        resume: '',
        comments: [
          { comment: '', photo: '/static-img/avatar.png', id: Date.now() },
        ],
      },
    };
  },
  computed: {
    subjects() {
      switch (this.schoolLevel) {
        case 'elementary-school':
          return [
            {
              label: 'chinese',
              text: '國文',
            },
            {
              label: 'math',
              text: '數學',
            },
            {
              label: 'english',
              text: '英文',
            },
            {
              label: 'natural',
              text: '自然',
            },
            {
              label: 'society',
              text: '社會',
            },
          ];
        case 'junior-high-school':
          return [
            {
              label: 'chinese',
              text: '國文',
            },
            {
              label: 'math',
              text: '數學',
            },
            {
              label: 'english',
              text: '英文',
            },
            {
              label: 'natural',
              text: '自然',
            },
            {
              label: 'society',
              text: '社會',
            },
          ];
        case 'high-school':
          return [
            {
              label: 'chinese',
              text: '國文',
            },
            {
              label: 'math',
              text: '數學',
            },
            {
              label: 'english',
              text: '英文',
            },
            {
              label: 'physical',
              text: '物理',
            },
            { label: 'chemistry', text: '化學' },
            { label: 'biology', text: '生物' },
            {
              label: 'history',
              text: '歷史',
            },
            {
              label: 'geography',
              text: '地理',
            },
            {
              label: 'citizen',
              text: '公民',
            },
          ];
        default:
          return [];
      }
    },
  },
  methods: {
    replaceQuery() {
      let newQuery = {
        schoolLevel: this.schoolLevel,
        subject: this.subject,
        page: this.currentPage,
      };
      this.$router.replace({ query: newQuery });
    },
    changeSchoolLevel() {
      this.subject = '';
      this.replaceQuery();
      this.search();
    },
    changeSubject() {
      this.replaceQuery();
      this.search();
    },
    pageChange() {
      this.replaceQuery();
      this.search();
    },
    createTeacher() {
      this.isCreate = true;
      this.teacherForm = {
        school_level: '',
        subject: '',
        name: '',
        photo: '/static-img/avatar.png',
        resume: '',
        comments: [
          { comment: '', photo: '/static-img/avatar.png', id: Date.now() },
        ],
      };
      this.teacherEditorVisible = true;
    },
    editTeacher(data) {
      this.isCreate = false;
      this.teacherForm = _.cloneDeep(data);
      this.teacherEditorVisible = true;
    },
    async remove(id) {
      Swal.fire({
        title: '確定刪除？',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: '取消',
        confirmButtonText: '確定',
      }).then(async (result) => {
        if (result.value) {
          try {
            await Api.removeTeacher(id);
            _.remove(this.teachersData.list, (teacher) => {
              return teacher.id == id;
            });
            this.$set(this.teachersData.list, this.teachersData.list);
            this.$message({
              message: '刪除成功',
              type: 'success',
            });
          } catch (e) {
            Swal.fire({
              title: 'Error!',
              text: '發生錯誤，請檢查網路或聯絡管理人員',
              icon: 'error',
            });
            window.console.log(e);
          }
        }
      });
    },
    async search() {
      const query = {
        school_level: this.schoolLevel,
        subject: this.subject,
        page: this.currentPage,
        size: this.size,
      };
      const res = await Api.getTeacherList(query);
      this.teachersData = res.data;
    },
    levelName(val) {
      switch (val) {
        case 'elementary-school':
          return '國小';
        case 'junior-high-school':
          return '國中';
        case 'high-school':
          return '高中';
      }
    },
    subjectName(val) {
      switch (val) {
        case 'chinese':
          return '國文';
        case 'math':
          return '數學';
        case 'english':
          return '英文';
        case 'natural':
          return '自然';
        case 'society':
          return '社會';
        case 'physical':
          return '物理';
        case 'chemistry':
          return '化學';
        case 'biology':
          return '生物';
        case 'history':
          return '歷史';
        case 'geography':
          return '地理';
        case 'citizen':
          return '公民';
      }
    },
    async saveTeacher(teacherForm) {
      try {
        if (this.isCreate) {
          await Api.createTeacher(teacherForm);
          this.init();
          this.teacherEditorVisible = false;
          this.$message({
            message: '新增成功',
            type: 'success',
          });
        } else {
          await Api.updateTeacher(teacherForm);
          this.init();
          this.teacherEditorVisible = false;
          this.$message({
            message: '修改成功',
            type: 'success',
          });
        }
      } catch (e) {
        Swal.fire({
          title: 'Error!',
          text: '發生錯誤，請檢查網路或聯絡管理人員',
          icon: 'error',
        });
        window.console.log(e);
      }
    },
    init() {
      this.isCreate = false;
      this.teacherForm = {
        school_level: '',
        subject: '',
        name: '',
        photo: '/static-img/avatar.png',
        resume: '',
        comments: [
          { comment: '', photo: '/static-img/avatar.png', id: Date.now() },
        ],
      };
      this.currentPage = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.schoolLevel = this.$route.query.schoolLevel
        ? this.$route.query.schoolLevel
        : 'elementary-school';
      this.subject = this.$route.query.subject ? this.$route.query.subject : '';
      this.search();
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  components: {
    TeacherEditor,
  },
};
</script>

<style lang="scss" scoped>
.teacher-manager {
  .top {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;

    .radio-group {
      margin-right: 50px;
      display: flex;
      flex-direction: column;

      .school-level-radio {
        margin-bottom: 10px;
      }
    }
  }

  .teacher-photo {
    width: 100px;
    height: 100px;
  }
}
</style>
